'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const sortBy = require('lodash/sortBy');
import { Card, Button } from 'react-bootstrap';

const TemplateStore = require('../../stores/template_store_reflux');
const TemplateActions = require('../../actions/TemplateActions');
import TemplateListing from './TemplateListing';
import LoadingMainContent from '../loading/LoadingMainContent';

const propTypes = {};
const defaultProps = {};

class AdminTemplatesView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            templateStoreState: TemplateStore.getState(),
            actionId: null,
            active_id: -1,
        };
        this.addTemplateHandler = this.addTemplateHandler.bind(this);
        this.setActiveTemplate = this.setActiveTemplate.bind(this);
        this.unsubscribes = [TemplateStore.listen(this.onTemplateStoreChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    addTemplateHandler() {
        const actionId = uuid.v4();
        this.setState({ actionId: actionId }, () => {
            TemplateActions.createTemplate(actionId);
        });
    }

    onTemplateStoreChange(state) {
        let additionalState = {};
        if (this.state.actionId === state.action.id) {
            additionalState = {  ...additionalState, actionId: null };
        }
        if (state.action.new_template_id) {
            additionalState = {  ...additionalState, active_id: state.action.new_template_id };
        }

        this.setState({
            templateStoreState: state,
            ...additionalState
        });
    }

    setActiveTemplate(e) {
        this.setState({ active_id: Number(e.target.value) });
    }

    render() {
        if (!this.state.templateStoreState.initialized) {
            return <LoadingMainContent/>
        }

        const sortedTemplates = sortBy(this.state.templateStoreState.globalTemplates, tmpl => tmpl.id);
        const activeTemplate = sortedTemplates.find(t => t.id === this.state.active_id);
        return (
            <div className="container">
                <Card body bg="light">
                    <Button className="btn btn-primary" onClick={this.addTemplateHandler} disabled={!!this.state.actionId}>
                        Add New Template
                    </Button>
                </Card>
                <label className="margin-bottom-lg">{'Edit Template: '}
                    <select value={this.state.active_id} onChange={this.setActiveTemplate}>
                        <option hidden key={'none'} value={-1}>{'select...'}</option>
                        {sortedTemplates.map((template) => 
                            <option key={template.id} value={template.id}>
                                {template.name || ('unnamed ' + template.id)}
                            </option>
                        )}
                    </select>
                </label>
                {(activeTemplate) &&
                    <TemplateListing
                        key={this.state.active_id}
                        template={activeTemplate}
                        action={this.state.templateStoreState.action}
                    />
                }
            </div>
        );
    }
}

AdminTemplatesView.propTypes = propTypes;
AdminTemplatesView.defaultProps = defaultProps;

export default AdminTemplatesView;